import appCONST from './../../../../constants/app.constants';

export default function AdminFaxDetailsService(
    $http
) {
    'ngInject';

    Object.assign(this, {
        getPdfUrl,
        sendFaxToNewFaxNumber,
    });
    const resendFaxEndpoint = '/management/fax/resend';

    function sendFaxToNewFaxNumber(faxId, faxNumber) {
        const url = `${appCONST.apiUrl}${resendFaxEndpoint}`;
        const body = {
            hotelFaxIds: [faxId],
            faxNumber,
        };

        return $http.post(url, body)
            .then(({data}) => data);
    }

    function getPdfUrl(hash) {
        return `${appCONST.apiUrl}/management/fax/byhash/${hash}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-fax/admin-fax-details/admin-fax-details-service.js